import React from 'react'
import { GridContainer, GridItem, Image, Item, List } from './Infographics.styles'

/**
 * The FichaContractOrders component.
 */
const FichaContractOrders = () => (
  <GridContainer padding="0 0 8px">
    <GridItem sm={6} xs={12}>
      <Image alt="Imagen ayuda" src="/assets/images/accordion-examples/Ejemplo-FichaDeContratos.svg" />
    </GridItem>
    <GridItem sm={6} xs={12}>
      <List>
        <Item>Selecciona el año que deseas consultar.</Item>
        <Item>Número de órdenes de compra que requieren contrato.</Item>
        <Item>Número de órdenes de compra con contrato, clic para ver tabla de detalles.</Item>
        <Item>Número de órdenes de compra sin contrato, clic para ver tabla de detalles.</Item>
        <Item>Indicadores de contratos por categoría.</Item>
        <Item>Indicadores de contratos por ejecución.</Item>
        <Item>
          Indicadores relevantes de los contratos del organismo comprador, al dar clic podrás ver una tabla con el
          detalle de dicho indicador.
        </Item>
      </List>
    </GridItem>
  </GridContainer>
)

export default FichaContractOrders
